/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'share': {
    width: 26,
    height: 32,
    viewBox: '0 0 26 32',
    data: '<path pid="0" _fill="#757575" d="M17.778 23.111l-7.716-5.76c.089-.406.141-.872.142-1.35V16a3.676 3.676 0 00-.149-1.342l.007.026 7.716-5.796a4.925 4.925 0 003.357 1.316h.003a5.103 5.103 0 10-5.137-5.102c.024.512.074.989.152 1.458l-.01-.071-7.68 5.76a4.994 4.994 0 00-3.359-1.316h-.001a5.102 5.102 0 100 10.204h.003c1.298 0 2.479-.5 3.361-1.318l-.003.003 7.716 5.76a7.887 7.887 0 00-.142 1.304v.044a4.96 4.96 0 001.249 3.298l-.005-.005a5.067 5.067 0 10.492-7.107l.006-.005zm3.378-20.195a2.187 2.187 0 110 4.374h-.089a2.116 2.116 0 01-2.099-2.115l.001-.075v.004c0-1.208.979-2.187 2.187-2.187zm-16 15.306a2.151 2.151 0 01-2.241-2.149l.001-.077V16a2.187 2.187 0 112.187 2.187zm16 10.934h-.089a2.116 2.116 0 01-2.099-2.116l.001-.075v.004a2.187 2.187 0 112.187 2.187z"/>'
  }
})
